import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }

import {useHead} from "@vueuse/head";
import BackgroundAudioPlayer from "@/components/UI/AudioPlayer/BackgroundAudioPlayer.vue";
import ImageViewer from "@/components/UI/ImageViewer/ImageViewer.vue";
import HintsViewer from "@/components/Home/Content/HintsViewer.vue";
import BlockViewer from "@/components/Home/Content/BlockViewer.vue";
import {Notifications} from "@kyvg/vue3-notification";
import ServiceWorkerUpdatePopup from "@/pwa/components/ServiceWorkerUpdatePopup.vue";
import SubscriptionPopup from "@/components/User/Settings/Popup/SubscriptionPopup.vue";
import ConfirmationPopup from "@/components/UI/Pupup/ConfirmationPopup.vue";
import GoalDonePopup from "@/components/Goal/Popup/GoalDonePopup.vue";
import TimeZonePopup from "@/components/User/Auth/TimeZonePopup.vue";
import Notification from "@/components/UI/Notification.vue";
import AboutSubscriptionPopup from "@/components/User/Settings/Popup/AboutSubscriptionPopup.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useHead({
  title: 'Magic moon'
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    _createVNode(BackgroundAudioPlayer),
    _createVNode(ImageViewer),
    _createVNode(HintsViewer),
    _createVNode(BlockViewer),
    _createVNode(Notification),
    _createVNode(ServiceWorkerUpdatePopup),
    _createVNode(SubscriptionPopup),
    _createVNode(AboutSubscriptionPopup),
    _createVNode(ConfirmationPopup),
    _createVNode(GoalDonePopup),
    _createVNode(TimeZonePopup)
  ]))
}
}

})